import * as React from "react";
import * as ReactDOM from "react-dom";
import { ComboBox, IComboBoxValues } from "../../lib/components/ComboBox";
import { IEventWindow } from "../../../interfaces/models/IEvent";
import Ajax from "../../lib/Ajax";
import {SharedCompUserList, IUserItem} from "./SharedCompUserList";
import { Checkbox } from "../../avernus/checkbox/source/Checkbox";

interface ISharedCompProps {
    sharedMode:string
    editMode:boolean
    sharedUserIds:string
    invaitedUserIds:string
    invaitedAndAcceptedUserIds:string
    invaitedAndNotAcceptedUserIds:string
}
interface IAddUserSource extends IComboBoxValues{
    img:string
    affinity:string
}

interface ISharedCompState {
    sharedMode:string
    sharedSource:Array<IComboBoxValues>
    showInivteBox:boolean
    addUserSource:Array<IAddUserSource>
    addUserValue:string
    addUserLabel:string
    sharedUserIds:Array<number> // NOTE: sharedMode alapján kitölti
    invaitedUserIds:Array<number> // NOTE: meghívottak és a részt vesznekes
    invaitedAndAcceptedUserIds:Array<number> // NOTE: meghívottak és a részt vesznekes
    invaitedAndNotAcceptedUserIds:Array<number> // NOTE: meghívottak ésnem vesznek részt

}

export class SharedComp extends React.Component<ISharedCompProps, ISharedCompState>{

    constructor(props:ISharedCompProps){
        super(props);
        this.init();
    }

    private init():void{
        this.state = {
            sharedMode: this.props.sharedMode,
            showInivteBox: false,
            sharedSource: [
                {
                    label: 'Meghívott',
                    value: 'Invited'
                },
                {
                    label: 'Mindenki',
                    value: 'Everyone'
                }
            ],
            addUserSource: [],
            addUserValue: '',
            addUserLabel: '',
            sharedUserIds: this.convertToArray(this.props.sharedUserIds),
            invaitedUserIds: this.convertToArray(this.props.invaitedUserIds),
            invaitedAndAcceptedUserIds: this.convertToArray(this.props.invaitedAndAcceptedUserIds),
            invaitedAndNotAcceptedUserIds: this.convertToArray(this.props.invaitedAndNotAcceptedUserIds)
        };
        this.addVariablesToWidnowObject();
        // this.changeSharedMode(this.props.sharedMode);
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/user/getFamily', 'POST', {}, (data) =>{
            var addUserSource:Array<IAddUserSource>  = [];
            for (var key in data.live) {
                var item = data.live[key];
                var itemName = item.name;
                if ( item.affinity.toString() !== '' ) {
                    itemName += ' ('+item.affinity+')';
                }
                addUserSource.push({
                    label: itemName,
                    value: item.id,
                    img: item.img,
                    affinity: item.affinity
                });
            }
            this.setState({
                 addUserSource: addUserSource
            } as ISharedCompState);
        });

    }

    private addVariablesToWidnowObject():void{
        (window as IEventWindow).sharedUserIds = this.convertArrayToSeparetedString(this.state.sharedUserIds);
        (window as IEventWindow).invaitedUserIds = this.convertArrayToSeparetedString(this.state.invaitedUserIds);
    }

    private convertToArray(source:string):Array<number>{
        var ret:Array<number> = [];
        if ( source.indexOf('|') > -1 ) {
            source = source.substr(1, source.length -2);
            var temp = source.split('|');
            for (var key in temp) {
                var item = parseInt(temp[key]);
                if ( item !== NaN ) {
                    ret.push(item);
                }
            }
        }
        return ret;
    }

    private convertArrayToSeparetedString(source:Array<string|number>):string{
        var ret:string = '';
        if ( source.length > 0 ) {
            return '|' + source.join('|') + '|';
        }
        return ret;
    }

    private getSharedModeLabel(value:string):string{
        for (var key in this.state.sharedSource) {
            var item = this.state.sharedSource[key];
            if ( item.value === value ) {
                return item.label;
            }
        }
        return '';
    }

    private sharedModeChangeHandler(value:string): void {
        this.setState({
             sharedMode: value
        } as ISharedCompState);
        this.changeSharedMode(value);
    }

    private changeSharedMode(value?:string):void{
        if ( value === undefined) {
            var value = this.state.sharedMode;
        }

        (window as IEventWindow).sharedMode = value;
        var sharedUserIds:Array<number> = [];
        switch (value){
            case 'Invited':
                sharedUserIds = this.state.invaitedUserIds;
            break;
            case 'Everyone':
                for (var key in this.state.addUserSource) {
                    sharedUserIds.push(parseInt(this.state.addUserSource[key].value));
                }
            break;
        }
        this.setState({
             sharedUserIds: sharedUserIds
        } as ISharedCompState, ()=>{
            this.addVariablesToWidnowObject();
        });

    }

    private showInviteBoxClickHandler(evt): void {
        evt.preventDefault();
        this.setState({
             showInivteBox: !this.state.showInivteBox
        } as ISharedCompState);
    }

    private getInvaitedUserList():Array<IUserItem>{
        var ret:Array<IUserItem> = [];
        for (var key in this.state.addUserSource) {
            var item = this.state.addUserSource[key];
            var itemId:number = parseInt(item.value);
            if ( this.state.invaitedUserIds.indexOf(itemId) > -1 ) {
                var status:string = 'függőben';
                if ( this.state.invaitedAndAcceptedUserIds.indexOf(itemId) > -1 ) {
                    status = 'részt vesz';
                }else if ( this.state.invaitedAndNotAcceptedUserIds.indexOf(itemId) > -1 ) {
                    status = 'nem vesz részt';
                }
                ret.push({
                    id:          itemId,
                    name:        item.label,
                    img:         item.img,
                    affinity:    status
                    // affinity:    item.affinity
                });
            }

        }
        return ret;
    }

    private invateUserClickHandler(value:string, label:string): void {
        var invaitedUserIds = this.state.invaitedUserIds;
        var userId:number = parseInt(value);

        if ( invaitedUserIds.indexOf(userId) === -1) {
            invaitedUserIds.push(userId);
            value = '';
            label = '';
        }
        this.setState({
             addUserValue: value,
             addUserLabel: label,
             invaitedUserIds: invaitedUserIds
        } as ISharedCompState, () => {
            this.changeSharedMode();
        });
    }

    private removeInvaitedUser(id:number): void {
        var invaitedUserIds = this.state.invaitedUserIds;
        var index = invaitedUserIds.indexOf(id);

        if ( index > -1) {
            invaitedUserIds.splice(index,1);
            this.setState({
                invaitedUserIds: invaitedUserIds
            } as ISharedCompState, () => {
                this.changeSharedMode();
            });
        }
    }

    private radiobuttonChangeHandler(checked:boolean, value:string): void {
        console.log('cehckbox test');
        // if ( checked === true) {
            console.log(checked, 'itt jártam');
            this.sharedModeChangeHandler(value);
        // }
    }
    render() {
        return (
            <div>
                <div className="row bgw">
                    <h3>Ki láthatja?</h3>
                        { this.props.editMode === true?
                            <div>
                                <Checkbox
                                 key={ 'checkbox_1_' + Math.random() }
                                 defaultChecked={ this.state.sharedMode==='Everyone'?true:false }
                                 label="Mindenki"
                                 value = "Everyone"
                                 radiobuttonValue = { this.state.sharedMode }
                                 checkedIconClass="radiobtn_checked"
                                 notCheckedIconClass="radiobtn_not_checked"
                                 onChange = { (checked, value) => {
                                     this.radiobuttonChangeHandler(checked, value);
                                 }}
                                 />
                                <Checkbox
                                 key={ 'checkbox_2_' + Math.random() }
                                 defaultChecked={ this.state.sharedMode==='Invited'?true:false }
                                 label="Meghívottak"
                                 value = "Invited"
                                 radiobuttonValue = { this.state.sharedMode }
                                 checkedIconClass="radiobtn_checked"
                                 notCheckedIconClass="radiobtn_not_checked"
                                 onChange = { (checked, value) => {
                                     this.radiobuttonChangeHandler(checked, value);
                                 }}
                                 />
                            </div>
                            :<div>
                                { this.getSharedModeLabel(this.state.sharedMode) }
                            </div>}
                </div>
                <div className="row bgw shared_comp_user_list added_user_box">
                    <h3>Résztvevők</h3>
                      { this.props.editMode === true?<div>
                        <div>
                            <a title="Új résztvevő meghívása" className="add_new_btn" onClick={ e => this.showInviteBoxClickHandler(e) }
                                >
                                    <span className="add_new_icon"></span> <span className="text">
                                    Új családtag meghívása
                                </span>
                            </a>
                        </div>
                        { this.state.showInivteBox === true?<div>
                            <div className="addUser">
                                <ComboBox
                                    placeholder="Új családtag meghívása"
                                    currentValue = { this.state.addUserValue }
                                    currentLabel = { this.state.addUserLabel }
                                    source = { this.state.addUserSource}
                                    changed = { (value, label) => this.invateUserClickHandler(value, label) }
                                />
                            </div>
                        </div>:'' }


                    </div>:'' }
                    <SharedCompUserList title={ null } emptyText="" editMode={this.props.editMode} showJustInnerDiv={true} userList={ this.getInvaitedUserList() } removeItem={ id => this.removeInvaitedUser(id) } />
                </div>
            </div>
        );
    }
}
export class InitSharedComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('shared_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.render(<SharedComp sharedMode="" editMode={ false } sharedUserIds="" invaitedUserIds="" invaitedAndAcceptedUserIds="" invaitedAndNotAcceptedUserIds="" />, div);
        }
    }
}
export class ReInitSharedComp {
    constructor(sharedMode:string, sharedUserIds:string, invaitedUserIds:string, invaitedAndAcceptedUserIds:string, invaitedAndNotAcceptedUserIds:string, editMode:boolean) {
        var div: HTMLDivElement = document.getElementById('shared_comp') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(<SharedComp sharedMode={ sharedMode } sharedUserIds={ sharedUserIds } invaitedUserIds={ invaitedUserIds } invaitedAndAcceptedUserIds={invaitedAndAcceptedUserIds} invaitedAndNotAcceptedUserIds={invaitedAndNotAcceptedUserIds} editMode= { editMode } />, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/event/SharedCom.tsx